import { DiagramMarkers } from "@/app/features/diagrams/components/shared/DiagramMarkers";
import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";
import { StateMachineFlows } from "./StateMachineFlows";
import { StateMachineLegend } from "./StateMachineLegend";

const stateMachineNodes = [
  {
    id: "idle",
    x: 68,
    y: 202,
    width: 76,
    height: 76,
    label: "IDLE",
    sublabel: "S0",
    shape: "circle" as const,
  },
  {
    id: "extract",
    x: 198,
    y: 194,
    width: 92,
    height: 92,
    label: "EXTRACT",
    sublabel: "S1",
    eyebrow: "LLM AGENT",
    variant: "llm" as const,
    shape: "circle" as const,
  },
  {
    id: "validate",
    x: 392,
    y: 190,
    width: 100,
    height: 100,
    label: "VALIDATE",
    sublabel: "S2",
    eyebrow: "FSM GATE",
    variant: "brass" as const,
    shape: "double-circle" as const,
  },
  {
    id: "repair",
    x: 398,
    y: 41,
    width: 88,
    height: 88,
    label: "REPAIR",
    sublabel: "S3 (Retry)",
    eyebrow: "LLM AGENT",
    variant: "repair" as const,
    shape: "circle" as const,
  },
  {
    id: "commit",
    x: 592,
    y: 196,
    width: 88,
    height: 88,
    label: "COMMIT",
    sublabel: "S4",
    eyebrow: "MUTATION",
    variant: "success" as const,
    shape: "circle" as const,
  },
  {
    id: "done",
    x: 590,
    y: 359,
    width: 92,
    height: 92,
    label: "DONE",
    sublabel: "SUCCESS",
    variant: "success" as const,
    shape: "double-circle" as const,
  },
  {
    id: "escalate",
    x: 396,
    y: 359,
    width: 92,
    height: 92,
    label: "ALERT",
    sublabel: "HUMAN OPS",
    variant: "fallback" as const,
    shape: "double-circle" as const,
  },
];

export function StateMachineDrawing() {
  return (
    <>
      <DiagramMarkers prefix="smv-" />
      <StateMachineFlows />
      {stateMachineNodes.map((node) => (
        <DiagramNode key={node.id} {...node} />
      ))}
      <StateMachineLegend />
    </>
  );
}
